{
  "REPORT": {
    "HEADER": "Conversaciones",
    "LOADING_CHART": "Cargando datos del gráfico...",
    "NO_ENOUGH_DATA": "No hemos recibido suficientes puntos de datos para generar el informe. Inténtalo de nuevo más tarde.",
    "DOWNLOAD_AGENT_REPORTS": "Descargar reportes de agente",
    "DATA_FETCHING_FAILED": "Error al obtener datos, por favor intente nuevamente.",
    "SUMMARY_FETCHING_FAILED": "No se pudo obtener el resumen, por favor inténtalo de nuevo más tarde.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversaciones",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mensajes recibidos",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mensajes enviados",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Tiempo de primera respuesta",
        "DESC": "( Media )",
        "INFO_TEXT": "Número total de conversaciones utilizadas en el cálculo:",
        "TOOLTIP_TEXT": "Tiempo de primera respuesta es {metricValue} (basado en {conversationCount} conversaciones)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tiempo de resolución",
        "DESC": "( Media )",
        "INFO_TEXT": "Número total de conversaciones utilizadas en el cálculo:",
        "TOOLTIP_TEXT": "El tiempo de resolución es {metricValue} (basado en {conversationCount} conversaciones)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Número de resoluciones",
        "DESC": "( Total )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Número de resoluciones",
        "DESC": "( Total )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Recuento de traspasos",
        "DESC": "( Total )"
      },
      "REPLY_TIME": {
        "NAME": "Tiempo de espera del cliente",
        "TOOLTIP_TEXT": "El tiempo de espera es {metricValue} (basado en {conversationCount} conversaciones)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "LAST_7_DAYS": "Últimos 7 días",
      "LAST_30_DAYS": "Últimos 30 días",
      "THIS_MONTH": "Este mes",
      "LAST_MONTH": "El mes pasado",
      "LAST_3_MONTHS": "Últimos 3 meses",
      "LAST_6_MONTHS": "Últimos 6 meses",
      "LAST_YEAR": "Último año",
      "CUSTOM_DATE_RANGE": "Rango de fechas personalizado",
      "TODAY": "Hoy",
      "YESTERDAY": "Ayer"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Aplicar",
      "PLACEHOLDER": "Seleccione rango de fechas"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Agrupar por",
    "DURATION_FILTER_LABEL": "Duración",
    "GROUPING_OPTIONS": {
      "DAY": "Día",
      "WEEK": "Semana",
      "MONTH": "Mes",
      "YEAR": "Año"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Día"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Día"
      },
      {
        "id": 2,
        "groupBy": "Semana"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Día"
      },
      {
        "id": 2,
        "groupBy": "Semana"
      },
      {
        "id": 3,
        "groupBy": "Mes"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 2,
        "groupBy": "Semana"
      },
      {
        "id": 3,
        "groupBy": "Mes"
      },
      {
        "id": 4,
        "groupBy": "Mes"
      }
    ],
    "BUSINESS_HOURS": "Horarios",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Limpiar filtros",
      "EMPTY_LIST": "No se encontraron resultados"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Conversaciones: {count}",
      "RESULT_COUNT_MESSAGE": "Mensajes: {count}",
      "EMPTY": "No se encontraron registros para esta barra.",
      "ERROR": "No se pudieron cargar los registros. Inténtalo de nuevo.",
      "LOAD_MORE": "Cargar más",
      "PREVIOUS_BUCKET": "Barra anterior",
      "NEXT_BUCKET": "Barra siguiente",
      "UNKNOWN_CONTACT": "Contacto desconocido",
      "UNKNOWN_INBOX": "Bandeja de entrada desconocida",
      "UNASSIGNED_AGENT": "Sin asignar",
      "NO_MESSAGE_CONTENT": "Mensaje sin contenido",
      "MESSAGE_CREATED_AT": "Mensaje creado el {time}",
      "EVENT_OCCURRED_AT": "Evento ocurrido el {time}",
      "INCOMING_MESSAGE": "Mensaje entrante",
      "OUTGOING_MESSAGE": "Mensaje saliente",
      "VIEW_ALL": "Ver en conversaciones",
      "VIEW_ALL_LIMIT": "Solo las barras con {limit} conversaciones como máximo se abren en la lista de conversaciones.",
      "HIDDEN_COUNT": "No se muestran porque no eres miembro de su bandeja de entrada: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Mostrando {start} a {end} de {total} resultados",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Resumen de agentes",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "Cargando datos del gráfico...",
    "NO_ENOUGH_DATA": "No hemos recibido suficientes puntos de datos para generar el informe. Inténtalo de nuevo más tarde.",
    "DOWNLOAD_AGENT_REPORTS": "Descargar reportes de agente",
    "FILTER_DROPDOWN_LABEL": "Seleccionar agente",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversaciones",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mensajes entrantes",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mensajes salientes",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Tiempo de primera respuesta",
        "DESC": "( Media )",
        "INFO_TEXT": "Número total de conversaciones utilizadas en el cálculo:",
        "TOOLTIP_TEXT": "Tiempo de primera respuesta es {metricValue} (basado en {conversationCount} conversaciones)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tiempo de resolución",
        "DESC": "( Media )",
        "INFO_TEXT": "Número total de conversaciones utilizadas en el cálculo:",
        "TOOLTIP_TEXT": "El tiempo de resolución es {metricValue} (basado en {conversationCount} conversaciones)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Número de resoluciones",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Últimos 7 días"
      },
      {
        "id": 1,
        "name": "Últimos 30 días"
      },
      {
        "id": 2,
        "name": "Últimos 3 meses"
      },
      {
        "id": 3,
        "name": "Últimos 6 meses"
      },
      {
        "id": 4,
        "name": "Último año"
      },
      {
        "id": 5,
        "name": "Rango de fechas personalizado"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Aplicar",
      "PLACEHOLDER": "Seleccione rango de fechas"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Resumen de etiquetas",
    "DESCRIPTION": "Haz un seguimiento del rendimiento de las etiquetas con métricas clave como conversaciones, tiempos de respuesta, tiempos de resolución y casos resueltos.",
    "LOADING_CHART": "Cargando datos del gráfico...",
    "NO_ENOUGH_DATA": "No hemos recibido suficientes puntos de datos para generar el informe. Inténtalo de nuevo más tarde.",
    "DOWNLOAD_LABEL_REPORTS": "Descargar reportes de etiquetas",
    "FILTER_DROPDOWN_LABEL": "Seleecionar etiqueta",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversaciones",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mensajes entrantes",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mensajes salientes",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Tiempo de primera respuesta",
        "DESC": "( Media )",
        "INFO_TEXT": "Número total de conversaciones utilizadas en el cálculo:",
        "TOOLTIP_TEXT": "Tiempo de primera respuesta es {metricValue} (basado en {conversationCount} conversaciones)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tiempo de resolución",
        "DESC": "( Media )",
        "INFO_TEXT": "Número total de conversaciones utilizadas en el cálculo:",
        "TOOLTIP_TEXT": "El tiempo de resolución es {metricValue} (basado en {conversationCount} conversaciones)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Número de resoluciones",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Últimos 7 días"
      },
      {
        "id": 1,
        "name": "Últimos 30 días"
      },
      {
        "id": 2,
        "name": "Últimos 3 meses"
      },
      {
        "id": 3,
        "name": "Últimos 6 meses"
      },
      {
        "id": 4,
        "name": "Último año"
      },
      {
        "id": 5,
        "name": "Rango de fechas personalizado"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Aplicar",
      "PLACEHOLDER": "Seleccione rango de fechas"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Resumen de bandeja de entrada",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Cargando datos del gráfico...",
    "NO_ENOUGH_DATA": "No hemos recibido suficientes puntos de datos para generar el informe. Inténtalo de nuevo más tarde.",
    "DOWNLOAD_INBOX_REPORTS": "Descargar reportes de bandeja de entrada",
    "FILTER_DROPDOWN_LABEL": "Seleccione una bandeja de entrada",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversaciones",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mensajes entrantes",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mensajes salientes",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Tiempo de primera respuesta",
        "DESC": "( Media )",
        "INFO_TEXT": "Número total de conversaciones utilizadas en el cálculo:",
        "TOOLTIP_TEXT": "Tiempo de primera respuesta es {metricValue} (basado en {conversationCount} conversaciones)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tiempo de resolución",
        "DESC": "( Media )",
        "INFO_TEXT": "Número total de conversaciones utilizadas en el cálculo:",
        "TOOLTIP_TEXT": "El tiempo de resolución es {metricValue} (basado en {conversationCount} conversaciones)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Número de resoluciones",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Últimos 7 días"
      },
      {
        "id": 1,
        "name": "Últimos 30 días"
      },
      {
        "id": 2,
        "name": "Últimos 3 meses"
      },
      {
        "id": 3,
        "name": "Últimos 6 meses"
      },
      {
        "id": 4,
        "name": "Último año"
      },
      {
        "id": 5,
        "name": "Rango de fechas personalizado"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Aplicar",
      "PLACEHOLDER": "Seleccione rango de fechas"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Vista general del equipo",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Cargando datos del gráfico...",
    "NO_ENOUGH_DATA": "No hemos recibido suficientes puntos de datos para generar el informe. Inténtalo de nuevo más tarde.",
    "DOWNLOAD_TEAM_REPORTS": "Descargar informes del equipo",
    "FILTER_DROPDOWN_LABEL": "Seleccionar equipo",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversaciones",
        "DESC": "( Total )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Mensajes entrantes",
        "DESC": "( Total )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Mensajes salientes",
        "DESC": "( Total )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Tiempo de primera respuesta",
        "DESC": "( Media )",
        "INFO_TEXT": "Número total de conversaciones utilizadas en el cálculo:",
        "TOOLTIP_TEXT": "Tiempo de primera respuesta es {metricValue} (basado en {conversationCount} conversaciones)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tiempo de resolución",
        "DESC": "( Media )",
        "INFO_TEXT": "Número total de conversaciones utilizadas en el cálculo:",
        "TOOLTIP_TEXT": "El tiempo de resolución es {metricValue} (basado en {conversationCount} conversaciones)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Número de resoluciones",
        "DESC": "( Total )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Últimos 7 días"
      },
      {
        "id": 1,
        "name": "Últimos 30 días"
      },
      {
        "id": 2,
        "name": "Últimos 3 meses"
      },
      {
        "id": 3,
        "name": "Últimos 6 meses"
      },
      {
        "id": 4,
        "name": "Último año"
      },
      {
        "id": 5,
        "name": "Rango de fechas personalizado"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Aplicar",
      "PLACEHOLDER": "Seleccione rango de fechas"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "Reporte de encuestas de satisfacción",
    "NO_RECORDS": "No hay respuestas de encuestas de satisfacción disponibles.",
    "DOWNLOAD": "Descargar reportes CSAT",
    "DOWNLOAD_FAILED": "Error al descargar los informes CSAT",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Elegir agentes"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Contacto",
        "AGENT_NAME": "Agente asignado",
        "RATING": "Calificación",
        "FEEDBACK_TEXT": "Realimentacion de Comentario"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Total de respuestas",
        "TOOLTIP": "Número total de respuestas recopiladas"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Puntuación de satisfacción",
        "TOOLTIP": "Número total de respuestas positivas / Número total de respuestas * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Tasa de respuesta",
        "TOOLTIP": "Número total de respuestas / Número total de mensajes de la encuesta de satisfacción enviados * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Informes de bot",
    "METRIC": {
      "TOTAL_CONVERSATIONS": {
        "LABEL": "Núm. de conversaciones",
        "TOOLTIP": "Número total de conversaciones manejadas por el bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total de respuestas",
        "TOOLTIP": "Número total de respuestas enviadas por el bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Tiempo de resolución",
        "TOOLTIP": "Número total de conversaciones resueltas por el bot / Número total de conversaciones manejadas por el bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Tasa de traspasos",
        "TOOLTIP": "Número total de conversaciones transmitidas a agentes / Número total de conversaciones manejadas por el bot * 100"
      },
      "CONVERSATION_COUNT": {
        "LABEL": "Número de conversaciones",
        "TOOLTIP": "Número total de conversaciones con mensajes del bot"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Número de respuestas",
        "TOOLTIP": "Número total de mensajes salientes"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Número de respuestas IA",
        "TOOLTIP": "Número total de mensajes de respuesta enviados por el bot"
      },
      "COPILOT_COUNT": {
        "LABEL": "Número de respuestas preparadas",
        "TOOLTIP": "Número total de sugerencias del copilot preparadas por el bot para los agentes"
      },
      "SUCCESS_RATE": {
        "LABEL": "Resueltas por IA",
        "TOOLTIP": "Porcentaje de conversaciones resueltas por IA sin transferencia a un agente"
      },
      "RESOLVE_TIME": {
        "LABEL": "Tiempo de resolución",
        "TOOLTIP": "Tiempo medio desde el primer mensaje del cliente hasta el último mensaje del bot/agente"
      }
    },
    "GROUP_BY": {
      "LABEL": "Agrupar por",
      "NONE": "No agrupar",
      "INBOXES": "Bandejas de entrada",
      "LABELS": "Etiquetas"
    },
    "GROUPED": {
      "CHART_TITLE": "Distribución por grupo",
      "BACK_TO_ALL": "Mostrar todo",
      "TABLE": {
        "INBOX": "Bandeja de entrada",
        "LABEL": "Etiqueta",
        "CONVERSATIONS": "Conversaciones",
        "MESSAGES": "Mensajes",
        "MESSAGES_TOOLTIP": "Número total de mensajes salientes",
        "AI_MESSAGES": "Respuestas IA",
        "AI_MESSAGES_TOOLTIP": "Número total de respuestas IA, seguido del número de valoraciones positivas y negativas de los usuarios finales",
        "THUMBS_UP_TOOLTIP": "Número de respuestas IA valoradas positivamente (pulgar arriba) por los usuarios finales",
        "THUMBS_DOWN_TOOLTIP": "Número de respuestas IA valoradas negativamente (pulgar abajo) por los usuarios finales",
        "AI_PERCENTAGE": "% IA",
        "AI_PERCENTAGE_TOOLTIP": "Porcentaje de respuestas IA del total de mensajes en este grupo",
        "PREPARED": "Respuestas preparadas",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Porcentaje de mensajes del total de mensajes pertenecientes a este grupo",
        "BOT_RESPONSES": "% Respuestas IA",
        "SUGGESTION_USED": "Respuestas usadas",
        "SUGGESTION_USED_TOOLTIP": "Porcentaje de respuestas preparadas en este grupo que fueron usadas por los agentes",
        "SUGGESTION_NOT_USED": "Respuestas no usadas",
        "SUGGESTION_NOT_USED_TOOLTIP": "Porcentaje de mensajes en este grupo que tenían una respuesta preparada pero no fue usada"
      },
      "NOTES": {
        "TITLE": "Cómo se calculan las métricas",
        "CONVERSATIONS": "Número de conversaciones que tienen al menos un mensaje saliente en el período seleccionado.",
        "MESSAGES": "Número total de mensajes salientes (no privados) enviados en el período seleccionado. Incluye tanto mensajes generados por IA como escritos por humanos.",
        "PERCENTAGE": "Porcentaje de mensajes de este grupo del total de mensajes salientes en todos los grupos.",
        "AI_MESSAGES": "Número de mensajes salientes enviados automáticamente por el bot de IA (sin incluir respuestas preparadas para los agentes). Los números entre paréntesis muestran cuántas de esas respuestas fueron valoradas positivamente (pulgar arriba) y negativamente (pulgar abajo) por los usuarios finales.",
        "BOT_RESPONSES_PCT": "Porcentaje de respuestas IA de este grupo del total de mensajes salientes en este grupo.",
        "PREPARED": "Número de sugerencias del copilot (respuestas preparadas) generadas por el bot de IA para los agentes en el período seleccionado. Estos son mensajes privados visibles solo para los agentes y no se cuentan como mensajes salientes, por lo que este número puede no correlacionarse con la columna Mensajes.",
        "SUGGESTION_USED": "Porcentaje de respuestas preparadas en este grupo que fueron usadas por los agentes. Esto puede no correlacionarse con el conteo de Respuestas Preparadas porque también puede incluir sugerencias generadas en períodos anteriores.",
        "SUGGESTION_NOT_USED": "Porcentaje de mensajes salientes en este grupo donde una sugerencia del copilot estaba disponible pero el agente respondió sin usarla. Solo se cuenta cuando el agente realmente envió una respuesta. Esto puede no correlacionarse con el conteo de Respuestas Preparadas porque también puede incluir sugerencias generadas en períodos anteriores."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Resumen",
    "LIVE": "En vivo",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Conversaciones abiertas",
      "LOADING_MESSAGE": "Cargando métricas de conversación...",
      "OPEN": "Abrir",
      "UNATTENDED": "Desatendido",
      "UNASSIGNED": "Sin asignar",
      "PENDING": "Pendientes"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Tráfico de Conversación",
      "NO_CONVERSATIONS": "No hay conversaciones",
      "CONVERSATION": "{count} conversación",
      "CONVERSATIONS": "{count} conversaciones",
      "DOWNLOAD_REPORT": "Descargar reporte"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Conversaciones por agentes",
      "LOADING_MESSAGE": "Cargando métricas del agente...",
      "NO_AGENTS": "No hay conversaciones por agentes",
      "TABLE_HEADER": {
        "AGENT": "Agente",
        "OPEN": "Abrir",
        "UNATTENDED": "Desatendido",
        "STATUS": "Estado"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Equipo",
        "OPEN": "Abrir",
        "UNATTENDED": "Desatendido",
        "STATUS": "Estado"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Estado del agente",
      "ONLINE": "En línea",
      "BUSY": "Ocupado",
      "OFFLINE": "Fuera de línea"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Domingo",
    "MONDAY": "Lunes",
    "TUESDAY": "Martes",
    "WEDNESDAY": "Miércoles",
    "THURSDAY": "Jueves",
    "FRIDAY": "Viernes",
    "SATURDAY": "Sábado"
  },
  "SLA_REPORTS": {
    "HEADER": "Informes de SLA",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Cargando datos de SLA...",
    "DOWNLOAD_SLA_REPORTS": "Descargar reportes de SLA",
    "DOWNLOAD_FAILED": "Error al descargar los informes de SLA",
    "DROPDOWN": {
      "ADD_FIlTER": "Añadir Filtro",
      "CLEAR_ALL": "Limpiar todo",
      "CLEAR_FILTER": "Limpiar filtros",
      "EMPTY_LIST": "No se encontraron resultados",
      "NO_FILTER": "No hay filtros disponibles",
      "SEARCH": "Buscar filtro",
      "INPUT_PLACEHOLDER": {
        "SLA": "Nombre de SLA",
        "AGENTS": "Nombre del agente",
        "INBOXES": "Nombre de la bandeja de entrada",
        "LABELS": "Nombre de la etiqueta",
        "TEAMS": "Nombre del equipo"
      },
      "SLA": "Política de SLA",
      "INBOXES": "Bandeja de entrada",
      "AGENTS": "Agente",
      "LABELS": "Etiqueta",
      "TEAMS": "Equipo"
    },
    "WITH": "con",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Tasa de Aciertos",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Número de Fallos",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Número de conversaciones",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Política",
        "CONVERSATION": "Conversación",
        "AGENT": "Agente"
      },
      "VIEW_DETAILS": "Ver detalles"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Subtotal",
    "NO_TEAM": "Sin equipo",
    "GROUP_BY_TEAMS": "Agrupar por equipos",
    "INBOX": "Bandeja de entrada",
    "AGENT": "Agente",
    "TEAM": "Equipo",
    "LABEL": "Etiqueta",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Número de resoluciones",
    "CONVERSATIONS": "Núm. de conversaciones",
    "TOTAL": "Total",
    "OUTGOING_CHATS": "Chats salientes",
    "OUTGOING_EMAILS": "Correos salientes",
    "PHONE_CALLS": "Llamadas telefónicas",
    "INBOUND_CALLS": "Llamadas entrantes",
    "OUTBOUND_CALLS": "Llamadas salientes",
    "TOTAL_ACTIVITIES": "Total de actividades",
    "ONLINE_TIME": "Tiempo en línea",
    "QUEUE_AVAILABLE_TIME": "Tiempo disponible en cola",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Número de mensajes salientes enviados por este agente",
      "OUTGOING_EMAILS": "Número de correos salientes enviados por este agente",
      "PHONE_CALLS": "Número total de llamadas telefónicas asignadas a este agente (suma de llamadas entrantes y salientes)",
      "TOTAL_ACTIVITIES": "Número total de actividades: llamadas entrantes + llamadas salientes + chats salientes + correos salientes",
      "INBOUND_CALLS": "Número de llamadas telefónicas entrantes asignadas a este agente",
      "OUTBOUND_CALLS": "Número de llamadas telefónicas salientes asignadas a este agente",
      "AVG_FIRST_RESPONSE_TIME": "Tiempo medio desde la creación de la conversación hasta la primera respuesta del agente en conversaciones asignadas a este agente",
      "AVG_RESOLUTION_TIME": "Tiempo medio desde la creación de la conversación hasta su resolución en conversaciones asignadas a este agente",
      "AVG_REPLY_TIME": "Tiempo medio que los clientes esperan entre su mensaje y la respuesta del agente en conversaciones asignadas a este agente",
      "ONLINE_TIME": "Tiempo total que el agente estuvo en línea u ocupado durante el período seleccionado",
      "QUEUE_AVAILABLE_TIME": "Tiempo total que el agente estuvo disponible en colas telefónicas durante el período seleccionado"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Informes de teléfono",
    "DESCRIPTION": "Realiza un seguimiento de las métricas de llamadas telefónicas con información detallada sobre llamadas entrantes y salientes, agrupadas por agente o bandeja de entrada para un análisis exhaustivo.",
    "AGENT_HEADER": "Informes de teléfono - Por agente",
    "INBOX_HEADER": "Informes de teléfono - Por bandeja de entrada",
    "DOWNLOAD_BUTTON": "Descargar informes de teléfono",
    "DOWNLOAD_PHONE_REPORTS": "Descargar informes de teléfono",
    "GROUP_BY": {
      "LABEL": "Agrupar por",
      "AGENT": "Agente",
      "INBOX": "Bandeja de entrada"
    },
    "TABLE": {
      "AGENT_NAME": "Nombre del agente",
      "INBOX_NAME": "Nombre de la bandeja de entrada",
      "TOTAL_CALLS": "Total",
      "INBOUND_CALLS": "Entrantes",
      "OUTBOUND_CALLS": "Salientes",
      "FAILED_OUTBOUND_CALLS": "Salientes fallidas",
      "AVG_AGENT_HANDLED_DURATION": "Duración media",
      "TOTAL_AGENT_HANDLED_DURATION": "Duración total",
      "AVG_RINGING_TIME": "Tiempo medio de timbre",
      "CONNECTED_OUTBOUND_PERCENTAGE": "% Éxito",
      "UNIQUE_CALLERS": "Llamantes únicos",
      "UNIQUE_CALLED_CONTACTS": "Llamados únicos",
      "UNANSWERED_MISSED_CALLS": "Perdidas sin seguimiento",
      "UNANSWERED_MISSED_PERCENTAGE": "% Perdidas sin contestar",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Perdidas sin seguimiento, devueltas insuficientemente",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "% Perdidas sin seguimiento, devueltas insuficientemente"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Número total de todas las llamadas (incluidas las no conectadas)",
      "INBOUND_CALLS": "Número de llamadas conectadas",
      "OUTBOUND_CALLS": "Número de todas las llamadas salientes (incluidas las no conectadas)",
      "FAILED_OUTBOUND_CALLS": "Número de llamadas salientes que no se pudieron conectar",
      "AVG_AGENT_HANDLED_DURATION": "Duración media de las llamadas atendidas por agentes",
      "TOTAL_AGENT_HANDLED_DURATION": "Duración total de todas las llamadas atendidas por agentes",
      "AVG_RINGING_TIME": "Tiempo medio que las llamadas estuvieron sonando antes de ser contestadas",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Porcentaje de llamadas salientes que se conectaron correctamente",
      "UNIQUE_CALLERS": "Número de contactos únicos que realizaron llamadas entrantes",
      "UNIQUE_CALLED_CONTACTS": "Número de contactos únicos a los que se llamó mediante llamadas salientes",
      "UNANSWERED_MISSED_CALLS": "Número de llamadas perdidas sin devolución exitosa (llamada conectada). Puede incluir llamadas que aún se pueden gestionar dentro del día laboral",
      "UNANSWERED_MISSED_PERCENTAGE": "Porcentaje de llamantes únicos cuyas llamadas se perdieron sin seguimiento (llamadas perdidas sin contestar / llamantes únicos)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Número de llamadas perdidas con menos de 2 intentos de devolución. Puede incluir llamadas que aún se pueden gestionar dentro del día laboral",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Porcentaje de llamantes únicos con menos de 2 intentos de devolución ((perdidas sin seguimiento - gestionadas suficientemente) / llamantes únicos)"
    },
    "EMPTY_STATE": {
      "TITLE": "No hay datos de llamadas telefónicas disponibles",
      "MESSAGE": "No hay llamadas telefónicas en el rango de fechas seleccionado. Intenta ajustar tus filtros o el rango de fechas."
    }
  }
}
